import React, { Component, useEffect, useMemo, useState } from 'react';
import blocks from './data/2023-05/ICDblocks.json';
import endpoint_info from './data/2023-05/endpoints_info__FG_pheno-r11_geno-r10__2023-05-17.json';
import networkDataCSV from './data/2023-05/trees_couples_delta.csv';
import Lists from './components/lists';
import Network from './components/network'
import Heatmap from './components/heatmap'
import Header from './components/header'
import * as d3 from "d3";

function App() {

  const initialURL = window.location.href
  const URLdata = new URLSearchParams(initialURL.split('?')[1]).get('data');
  const URLview = new URLSearchParams(initialURL.split('?')[1]).get('view');
  
  const risteysEP = useMemo(()=>new URLSearchParams(initialURL.split('?')[1]).get('endpoint'),[])
  
  
  const [search, setSearch] = useState()
  
  const [contentHeight, setContentHeight] = useState(window.innerHeight-53)
  const [subheader, setSubheader] = useState(false)

  var initialEndpoints = {}
  var initialHeatmap = []

  if (URLview === 'lists' || URLview === null) {
    blocks.forEach(block => {
      if (block.code === URLdata) initialEndpoints = block
    })
  }

  if (URLview === 'heatmap') {
    const columns = URLdata.split(',')
    
    columns.forEach(el => {
      const datum = endpoint_info.filter(endpoint => endpoint.code === el)[0]
      const endpoint = {
        code: el,
        longname: datum.longname,
        cases: datum.n_cases_all
      }
      initialHeatmap.unshift(endpoint)
    })
  }

  const [view, setView] = useState(URLview === null ? 'lists' : URLview)
  const [endpoints, setEndpoints] = useState((URLview === null || URLview === 'lists') ? initialEndpoints : {}) 
  const [network, setNetwork] = useState(URLview === 'network' ? URLdata : undefined)
  const [heatmap, setHeatmap] = useState(URLview === 'heatmap' ? initialHeatmap : [])

  const [networkData,setNetworkData] = useState([])
  const [networkRoots,setNetworkRoots] = useState([])

  function updateNetworkRoots (newRoot, oldRoots) {
    setNetworkRoots([newRoot, ...(oldRoots||[])])
  }
  
  useMemo(() => d3.csv(networkDataCSV).then(data=>setNetworkData(data)),[])
  
  

  if(risteysEP){
    updateURL ('network',risteysEP)
    setNetworkRoots([risteysEP])
  }

  const color = {
    gray: '#555',
    violet: '#b870ff',
    purple: '#5900b3',
    pink: '#f75aff',
    lightgray: '#e7e7e7',
    background: '#f0f0f0',
    darkpurple: '#2b065c',
    lightviolet: '#f0d9ff',
    lightpurple: '#e3dceb',
  }

  function formatName (name) {
    const formattedName = name.replaceAll('_', ' ').replaceAll('(', ' (').replaceAll('  ', ' ')
    return formattedName
  }

  function formatLongname (longname, name) {
    var final, trial

    if (longname === undefined) trial = retrieveLongname(name)
    else trial = longname

    if (trial === undefined) final = '–'
    else final = trial

    return final
}

  function formatCount (count, name) {
    var final, trial

    // if (count === undefined || count === null) trial = retrieveCount(name)
    // else trial = count

    if (count === undefined || count === null || count !== count ) final = '-'
    else final = count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return final
  }

  function formatRatio (ratio, count) {
    if (ratio === undefined || ratio === null || count === undefined || count === null) return '-'
    else return Math.round(ratio/count*100)+'%'
  }

  function formatPercentage (percentage) {
    return Math.round(percentage*100)+'%'
  }

  function formatJaccard (jaccard) {
    return Math.round(jaccard*1000)/1000
  }

  function formatShort (name) {
    if (name.length > 30) return name.slice(0,28)+ '...'
    else return name
  }

  const format = {
    name: formatName,
    longname: formatLongname,
    count: formatCount,
    ratio: formatRatio,
    short: formatShort,
    jaccard: formatJaccard,
    percentage: formatPercentage
  }

  // function updateURL (endpoint) {
  //   var currentURL = window.location.href,
  //       websiteURL = currentURL.split('?')[0]

  //   if (endpoint === undefined) { 
  //     var nextState = {additionalInformation: "Original URL"}
  //     window.history.replaceState(nextState, 'ICD view', websiteURL);
  //   }
  //   else {
  //     var nextURL = websiteURL + '?endpoint=' + endpoint;
  //     var nextState = {additionalInformation: 'Updated the URL with JS'};
  //     window.history.replaceState(nextState, endpoint, nextURL);
  //   }
  // }

  function updateURL (view, data) {
    var currentURL = window.location.href,
        websiteURL = currentURL.split('?')[0]

    var nextURL
    if (data === undefined) nextURL = websiteURL + '?view=' + view
    else nextURL = websiteURL + '?view=' + view + '&data=' + data;

    var nextState = {additionalInformation: 'Updated the URL with JS'};
    window.history.replaceState(nextState, view, nextURL);
  }
  


  function retrieveCount (name) {
    return endpoint_info.filter(el => el.code === name)[0].n_cases_all
  }

  function retrieveLongname (name) {
    return endpoint_info.filter(el => el.code === name)[0]?.longname
  }

  function retrieveGwas (name) {
    return endpoint_info.filter(el => el.code === name)[0].gwas_hits
  }

  function retrieveCore (name) {
    return endpoint_info.filter(el => el.code === name)[0].core_endpoint
  }

  const retrieve = {
    longname: retrieveLongname,
    count: retrieveCount,
    gwas: retrieveGwas,
    core: retrieveCore
  }

  function updateHeatmap (code, longname, cases) {
    if (heatmap.map(el => el.code).includes(code)) {
      setHeatmap(heatmap.filter(el => el.code !== code))
    } else {
      const endpoint = {
        code: code,
        longname: longname,
        cases: cases
      }
      const newHeatmap = [...heatmap]
      newHeatmap.unshift(endpoint)
      setHeatmap(newHeatmap)
    }
  }

  useEffect(()=>{

    window.addEventListener("resize", function () {setContentHeight(window.innerHeight-53)});
    d3.select("#search_bar_1").on("keypress", e => {if (e.key === "Enter") document.getElementById("search_btn_1").click()});
    d3.select("#search_btn_1").on("click", () => {
        const newSearch = document.getElementById('search_bar_1').target
        setSearch(newSearch)
      });
  })


  return (
    <div className="App">
      <Header 
        network={network}
        heatmap={heatmap}
        updateHeatmap={updateHeatmap}
        endpoints={endpoints}
        setEndpoints={setEndpoints}
        view={view}
        setView={setView}
        format={format}
        setSearch={setSearch}
      />

      <div id="content">
        {view === 'lists' && (
          <Lists
            blocks={blocks}
            endpoints={endpoints}
            setEndpoints={setEndpoints}
            contentHeight={contentHeight}
            color={color}
            format={format}
            // retrieve={retrieve}
            search={search}
            setSearch={setSearch}
            setView={setView}
            setNetwork={setNetwork}
            heatmap={heatmap}
            setHeatmap={setHeatmap}
            updateHeatmap={updateHeatmap}
            updateURL={updateURL}
            networkRoots = {networkRoots}
            updateNetworkRoots = {updateNetworkRoots}
        />)}
        {view === 'network' && (
          <Network 
            data={networkData}
            root={network}
            setRoot={setNetwork}
            blocks={blocks}
            color={color}
            format={format}
            retrieve={retrieve}
            contentHeight={contentHeight}
            setView={setView}
            heatmap={heatmap}
            setHeatmap={setHeatmap}
            updateHeatmap={updateHeatmap}
            updateURL={updateURL}
            roots = {networkRoots}
        />)}
        {view === 'heatmap' && (
          <Heatmap
            endpoints={heatmap}
            setEndpoints={updateHeatmap}
            color={color}
            format={format}
            setView={setView}
            heatmap={heatmap}
            contentHeight={contentHeight}
            updateURL={updateURL}
        />)}
      </div>
    </div>
  );
}

export default App;
